import { DocumentItem } from '@toggle/toggle';

import { getDocumentsPendingConsent } from '~/services/legal-documents/legal-documents-service';
import { create } from '~/utils/store/createStore';

interface DocStore {
  loading: boolean;
  error: boolean;
  docsPendingConsent: DocumentItem[];
  updateDocsPendingConsent: (docs: DocumentItem[]) => void;
  getDocsPendingConsent: () => Promise<void>;
}

export const useLegalDocuments = create<DocStore>(set => ({
  docsPendingConsent: [],
  error: false,
  loading: false,
  getDocsPendingConsent: async () => {
    set({ error: false, loading: true });
    const req = await getDocumentsPendingConsent();

    if (!req.error) {
      set({ docsPendingConsent: req.data, loading: false });
    } else {
      set({ error: true, loading: false });
    }
  },
  updateDocsPendingConsent: (docs: DocumentItem[]) => {
    set({ docsPendingConsent: docs });
  },
}));
